module.exports = __webpack_public_path__ + "static/media/TDLM.epub.cover.9aed321e.pdf";